import { useState, useLayoutEffect } from 'react';
import useWindowDimensions from './useWindowDimension';

const useCalculatePosition = (btnRect, modalRef) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const windowSize = useWindowDimensions();

  useLayoutEffect(() => {
    if (!(btnRect && modalRef.current)) return;
    const { left: rootLeft, bottom: rootBottom, top: rootTop } = btnRect;
    const { width: modalWidth, height: modalHeight } = modalRef.current.getBoundingClientRect();
    const { resizeHeight, resizeWidth } = windowSize;
    const newPosition = { left: rootLeft + 5, top: rootBottom + 5 };
    if (newPosition.left + modalWidth > resizeWidth) {
      newPosition.left = resizeWidth - modalWidth - 5;
    }
    if (newPosition.top + modalHeight > resizeHeight) {
      newPosition.top = rootTop - modalHeight + 5;
    }
    setPosition(newPosition);
  }, [btnRect, modalRef, windowSize]);

  return position;
};

export default useCalculatePosition;
